import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

const SMARTSTORE_URL = 'https://smartstore.naver.com/proactivecare';

const ProductsSection = () => (
  <section id="products" className="py-24 md:py-32 bg-[#f8f9fb]">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-0.5 bg-[#1a2b4a]" />
            <span className="text-[#1a2b4a] text-xs font-semibold tracking-[0.25em] uppercase">Our Products</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a2b4a] leading-tight">
            프리미엄<br />건강식품
          </h2>
        </div>
        <p className="text-gray-400 text-sm md:text-base max-w-xs leading-relaxed">
          엄선한 원료로 만든<br />최고 품질의 건강 솔루션
        </p>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-white rounded-xl overflow-hidden border border-gray-100 group hover:-translate-y-1.5 transition-transform duration-300"
          >
            {/* Image */}
            <Link to={`/product/${product.id}`} className="block relative w-full h-72 overflow-hidden bg-gray-50 cursor-pointer">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500 p-4"
              />
              <span className="absolute top-3 left-3 bg-white/90 text-[#1a2b4a] text-xs font-medium px-2.5 py-1 rounded-full">
                {product.category}
              </span>
            </Link>

            {/* Info */}
            <div className="p-5">
              <h3 className="text-base font-bold text-[#1a2b4a] mb-2">{product.name}</h3>
              <p className="text-sm text-gray-400 leading-relaxed mb-5 line-clamp-2">{product.desc}</p>
              <div className="flex items-center gap-3">
                <Link
                  to={`/product/${product.id}`}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1a2b4a] hover:gap-3 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  자세히 보기
                  <i className="ri-arrow-right-line text-base" />
                </Link>
                <span className="text-gray-200">|</span>
                <a
                  href={product.purchaseUrl && product.purchaseUrl !== '#purchase' ? product.purchaseUrl : SMARTSTORE_URL}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-400 hover:text-[#03C75A] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  구매하기
                  <i className="ri-external-link-line text-xs" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProductsSection;
